import { toast } from "@/hooks/use-toast";
import { Article } from "@/interfaces/Product";

export const checkExistance = (
  barcode: string,
  scannedProducts: Article[]
): boolean => {
  const exist = scannedProducts.find((product) => product.genCode === barcode);
  if (exist) {
    return true;
  }
  return false;
};

export function productValidation(
  products: Article[],
  barcode: string,
  scannedProducts: Article[]
): Article | number {
  const existingProduct = products.find(
    (product) => product.genCode === barcode
  );

  if (existingProduct) {
    if (scannedProducts.some((product) => product.genCode === barcode)) {
      return 1;
    }
    return existingProduct;
  } else {
    return 2;
  }
}
export const handleProductScan = (
  barcode: string,
  validProducts: Article[],
  colisArticles: Article[]
): Article[] | null => {
  const product = colisArticles.find((article) => article.genCode === barcode);

  if (!product || product.quantity === undefined) {
    toast({
      variant: "destructive",
      title: "Produit non trouvé",
      description: "Ce produit n'appartient pas à ce colis",
    });
    return null;
  }

  const existingProduct = validProducts.find((p) => p.genCode === barcode);
  if (!existingProduct) {
    if (product.quantity >= 1) {
      toast({
        variant: "success",
        title: "Produit ajouté",
        description: `${product.genCode} a été ajouté au scan`,
      });
      return [...validProducts, { ...product, quantity: 1 }];
    }
  } else {
    if (
      existingProduct.quantity !== undefined &&
      existingProduct.quantity < product.quantity
    ) {
      toast({
        variant: "success",
        title: "Quantité mise à jour",
        description: `Quantité de ${product.quantity} augmentée`,
      });
      return validProducts.map((p) =>
        p.genCode === barcode ? { ...p, quantity: (p.quantity || 0) + 1 } : p
      );
    } else {
      toast({
        variant: "destructive",
        title: "Quantité maximale atteinte",
        description: "Vous avez atteint la quantité maximale pour ce produit",
      });
    }
  }
  return null;
};
